export class ViewContext {
  entityNameSingular: string; // Text to be shown in UI, like "tenant"
  entityNamePlural: string; // Text to be shown in UI, like "tenants"
  formUrl: string; // The url of the form, like "tenant"
  listUrl: string; // The url of the list, like "tenants"
  generalFormMetaName?: any; // If given this is the name of the meta tha is fetched and used to create the UI
  tableColumns?: { id: string, title: string }[]; // The columns to be shown in the table (list)
}
